import { render, staticRenderFns } from "./OrderRule.vue?vue&type=template&id=be89dd86&scoped=true"
import script from "./OrderRule.vue?vue&type=script&lang=js"
export * from "./OrderRule.vue?vue&type=script&lang=js"
import style0 from "./OrderRule.vue?vue&type=style&index=0&id=be89dd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be89dd86",
  null
  
)

export default component.exports